<template>
  <el-dialog :title="'客訴事件'" :visible.sync="isShowDialog" @close="onClose">
    <!--form row-1-->
    <el-form
      :model="addComplainForm"
      :rules="rules"
      label-width="120px"
      label-position="left"
      ref="addComplainForm"
      class="add-complain-form"
    >
      <!-- form row-1 -->
      <el-row>
        <el-col :span="11">
          <el-form-item label="司機" prop="driverLabel">
            <el-autocomplete
              v-model="addComplainForm.driverLabel"
              :fetch-suggestions="querySearchAsync"
              placeholder="請輸入司機隊編/呼號"
              @select="onSelectDriver"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="客服種類" prop="typeId">
            <el-select v-model="addComplainForm.typeId" clearable>
              <el-option
                v-for="type in vx_typeList"
                :key="type.id"
                :label="type.name"
                :value="type.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--form row-2-->
      <el-row>
        <el-col :span="11">
          <el-form-item label="事件發生時間" prop="happenTime">
            <el-date-picker
              v-model="addComplainForm.happenTime"
              type="datetime"
              placeholder="事件發生時間"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="處理進度" prop="status">
            <el-select v-model="addComplainForm.status">
              <el-option
                v-for="status in COMPLAIN_STATUS"
                :key="status.key"
                :label="status.label"
                :value="status.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--form row-3-->
      <el-row>
        <el-col :span="11">
          <el-form-item label="立案人員" prop="createPersonName">
            <el-select
              v-model="addComplainForm.createPersonName"
              placeholder="請選擇立案人員"
              clearable
            >
              <el-option
                v-for="manager in managerList"
                :key="manager.id"
                :label="manager.managerName"
                :value="manager.managerName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="結案人員" prop="sealPersonId">
            <el-select
              v-model="addComplainForm.sealPersonId"
              placeholder="請選擇結案人員"
              clearable
            >
              <el-option
                v-for="manager in managerList"
                :key="manager.id"
                :label="manager.managerName"
                :value="manager.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- form textarea-1 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="事件內容" prop="eventContent">
            <el-input
              type="textarea"
              placeholder="請輸入事件內容"
              v-model="addComplainForm.eventContent"
              :autosize="{ minRows: 3 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- form textarea-2 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="處理描述" prop="processingDesc">
            <el-input
              type="textarea"
              placeholder="請輸入處理描述"
              v-model="addComplainForm.processingDesc"
              :autosize="{ minRows: 3 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- form footer  -->
    <span slot="footer" class="dialog-footer">
      <el-button
        :loading="isLoading"
        type="primary"
        @click="onSubmit('addComplainForm')"
      >
        新增
      </el-button>
      <el-button @click="isShowDialog = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { reqAddComplain } from '@/api/customerComplain'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { complainStatus } from '@/constants/customerComplain'
import { cookies } from '@/utils/cookies'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'

export default {
  data() {
    return {
      currentLoginServiceId: null,
      isLoading: false,
      addComplainForm: {
        /* 司機 */
        driverId: null,
        driverLabel: null,
        /* 客服種類 */
        typeId: null,
        /* 事件發生時間 */
        happenTime: null,
        /* 處理進度 */
        status: 0,
        /* 立案人員 */
        createPersonName: null,
        /* 結案人員 */
        sealPersonId: null,
        /* 事件內容 */
        eventContent: '',
        /* 處理描述 */
        processingDesc: '',
      },
      rules: {
        driverLabel: [
          {
            required: true,
            message: '請選擇司機',
            trigger: 'change',
          },
        ],
        typeId: [
          {
            required: true,
            message: '請選擇客服種類',
            trigger: 'change',
          },
        ],
        happenTime: [
          {
            type: 'date',
            required: true,
            message: '請選擇事件發生時間',
            trigger: 'change',
          },
        ],
        createPersonName: [
          {
            required: true,
            message: '請選擇立案人員',
            trigger: 'change',
          },
        ],
        eventContent: [
          {
            required: true,
            message: '請撰寫事件內容',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('managerStore', {
      vx_fetchComplainList: 'fetchComplainList',
    }),
    ...mapMutations('managerStore', {
      vx_setIsAddComplainDialog: 'SET_IS_ADD_COMPLAIN_DIALOG',
    }),
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.addComplainForm.driverId) {
            Notification({
              type: 'warning',
              message: '司機資料有誤，請再選擇一次',
            })
            return false
          }
          try {
            this.isLoading = true
            const {
              driverId,
              typeId,
              createPersonName,
              sealPersonId,
              eventContent,
              processingDesc,
              status,
              happenTime,
            } = this.addComplainForm
            const { success } = await reqAddComplain({
              driver_id: driverId,
              type_id: typeId,
              customer_id:
                this.vx_currentLoginServiceId /* 目前登入後台的客服id */,
              add_service: createPersonName /* 立案人員姓名 */,
              finishCustomerServiceId: sealPersonId /* 結案人員id */,
              event_content: eventContent,
              processing_description: processingDesc,
              status: status,
              /* 配合server調整為+0時區 */
              event_time: dayjs(happenTime)
                .subtract(8, 'hour')
                .format('YYYY-MM-DD HH:mm:ss'),
              code: cookies.get('GladTeamCode'),
            })
            if (success) {
              Notification({
                type: 'success',
                message: '新增客訴單成功',
              })
              this.resetForm()
              this.vx_fetchComplainList('afterAdd')
            } else {
              Notification({
                type: 'error',
                message: '新增客訴單失敗',
              })
            }
          } catch (e) {
            console.error(e)
            Notification({
              type: 'error',
              message: '新增客訴單失敗',
            })
          } finally {
            this.isLoading = false
          }
        } else {
          Notification({
            type: 'warning',
            message: '請完整輸入表單資訊',
          })
          return false
        }
      })
    },
    resetForm() {
      /* HACK: 或許有更好的方法，目前作法清除了表單資料2次 */
      this.$refs['addComplainForm'].resetFields()
      this.addComplainForm = {
        driverId: null,
        driverLabel: null,
        typeId: null,
        happenTime: null,
        status: 0,
        createPersonName: null,
        sealPersonId: null,
        eventContent: '',
        processingDesc: '',
      }
    },
    onClose() {
      this.vx_setIsAddComplainDialog(false)
    },
    /* 司機動態搜尋 */
    querySearchAsync(queryString, cb) {
      const filterdResults = queryString
        ? this.vx_driverList.filter(this.driverFilter(queryString))
        : this.vx_driverList
      const results = filterdResults.map((driver) => {
        return {
          value: `${driver.call_number}-${driver.name}`,
          id: String(driver.id),
        }
      })
      cb(results)
    },
    driverFilter(queryString) {
      return (state) =>
        state.call_number.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },
    onSelectDriver({ id }) {
      this.addComplainForm.driverId = id
    },
  },
  computed: {
    ...mapGetters({
      managerList: 'managerStore/getManagerList',
    }),
    ...mapState('managerStore', {
      vx_isAddComplainDialog: 'isAddComplainDialog',
      vx_driverList: 'driverList',
      vx_typeList: 'typeList',
      vx_currentLoginServiceId: 'currentLoginServiceId',
    }),
    isShowDialog: {
      get() {
        return this.vx_isAddComplainDialog
      },
      set(value) {
        this.vx_setIsAddComplainDialog(value)
      },
    },
  },
  created() {
    /* 新增客訴管理dialog，處理進度不出現全部的選項 */
    this.COMPLAIN_STATUS = complainStatus.slice(0, complainStatus.length - 1)
  },
}
</script>

<style scoped>
.el-form-item {
  width: 100%;
}

.el-date-picker {
  width: 100%;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-col {
  margin-right: 20px;
}

.el-col:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/components/AddComplainDialog.vue